import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '#environments/environment';
import { CRUDService } from '#services/api/crud.service';
import { PurchaseOrder } from 'models';
import { Equipment } from 'models';

export interface BulkImportItem {
    PurchaseOrderNumber?: string;
    RequestNumber?: string;
    SubmitDate?: string;
    FabricatorID: number;
}

export interface BulkItemError {
    RecordIndex: number;
    Identifier: string;
    Message: string;
}

export interface PoBulkResult {
    TotalRecords: number;
    SuccessCount: number;
    FailureCount: number;
    CreatedItems: PurchaseOrder[];
    Errors: BulkItemError[];
}

@Injectable()
export class PurchaseOrderService extends CRUDService<PurchaseOrder> {
    constructor(http: HttpClient) {
        super(http, `${environment.apiEndpoint}/purchase-orders`);
    }

    public getEquipment(purchaseOrderId: number): Observable<Equipment[]> {
        return this.http.get<Equipment[]>(`${this.url}/${purchaseOrderId}/equipments`);
    }

    public addEquipment(purchaseOrderId: number, equipmentId: number): Observable<Equipment[]> {
        return this.http.put<any>(`${this.url}/${purchaseOrderId}/add-equipment/${equipmentId}`, null);
    }

    public archive(id: number): Observable<any> {
        return this.http.put<any>(`${this.url}/${id}/archive`, null);
    }

    public addCheckedEquipmentsPurchaseOrders(purchaseOrderId: number, equiments: any): Observable<any> {
        return this.http.put<any>(`${this.url}/${purchaseOrderId}/add-multiple-equipment`, equiments);
    }

    public bulkImport(request: { PurchaseOrders: BulkImportItem[] }): Observable<PoBulkResult> {
        return this.http.post<PoBulkResult>(`${this.url}/bulk-import`, request);
    }

    public bulkImportFile(file: File): Observable<PoBulkResult> {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<PoBulkResult>(`${this.url}/bulk-import-file`, formData);
    }

    public downloadBulkImportTemplate(): Observable<Blob> {
        return this.http.get(`${this.url}/bulk-import-template`, { responseType: 'blob' });
    }
}
